import React, { useEffect, useState } from "react";
import BaseURL from "../../assets/utils/baseUrl";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";
import { useParams } from "react-router-dom";

function BeritaDetail() {
  useDocumentTitle("Informasi - BAPENDA BEKASI");

  const { id } = useParams(); // ✅ FIX utama

  const [informasi, setInformasi] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await fetch(
          BaseURL + "index.php/api/Berita?id=" + id + "&key=bapenda123"
        );

        const data = await res.json();

        setInformasi(data?.data?.[0] || null);
      } catch (err) {
        console.error("ERROR:", err);
        setInformasi(null);
      }
    };

    if (id) getData();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  // ⛔ loading
  if (!informasi) {
    return (
      <div className="page">
        <Header />
        <div style={{ padding: "40px", textAlign: "center" }}>
          Loading...
        </div>
        <Footer />
      </div>
    );
  }

  // ✅ pecah konten newline
  const kontenArr = informasi.konten
    ? informasi.konten.split("(_newline)")
    : [];

  return (
    <div className="page">
      <Header active="publikasi" />

      <div className="main-sb">
        <div className="content">
          <Breadcrumb path={informasi.judul} parent="berita" />

          <div className="informasi-detail-wrapper">
            <p className="informasi-detail-title">
              {informasi.judul}
            </p>

            <p className="informasi-detail-date">
              {informasi.created_date} | {informasi.user}
            </p>

            <div className="informasi-detail-image-wrapper">
              <img
                src={
                  informasi.thumbnail
                    ? BaseURL +
                      "assets/images/berita/" +
                      informasi.thumbnail
                    : "/no-image.png"
                }
                className="informasi-detail-image"
                alt={informasi.judul}
              />
            </div>

            <div className="informasi-detail-desc-wrapper">
              {kontenArr.map((item, index) => (
                <p key={index} className="informasi-detail-desc">
                  {item}
                </p>
              ))}
            </div>
          </div>
        </div>

        <Sidebar />
      </div>

      <Footer />
    </div>
  );
}

export default BeritaDetail;